export default __webpack_public_path__ + "static/media/android_button.669fcbb5.webp";